function Loader() {
  return (
    <div className="loadingLabel-container">
      <div className="loadingLabel">Cargando...</div>
    </div>
  );
}

export default Loader;
